/* bytahmid motion layer. Reveal-on-scroll for main content sections.
   Skips the first section (hero, LCP), skips anything already on screen,
   respects prefers-reduced-motion, and stays out of the theme editor. */
(function () {
  if (document.documentElement.classList.contains('shopify-design-mode')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var sections = document.querySelectorAll('#MainContent .shopify-section');
  if (sections.length < 2) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bt-in');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  sections.forEach(function (section, index) {
    if (index === 0) return;
    if (section.getBoundingClientRect().top < window.innerHeight) return;
    section.classList.add('bt-reveal');
    io.observe(section);
  });
})();
